var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Arrow Counterclockwise"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10 3.75C13.4518 3.75 16.25 6.54822 16.25 10C16.25 13.4518 13.4518 16.25 10 16.25C6.54822 16.25 3.75 13.4518 3.75 10C3.75 9.68637 3.7731 9.37814 3.81769 9.07691C3.87371 8.69853 3.59674 8.33333 3.21423 8.33333C2.90519 8.33333 2.63417 8.54686 2.58726 8.85232C2.5298 9.22649 2.5 9.60976 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C8.07911 2.5 6.32689 3.22213 5 4.40973V3.54167C5 3.19649 4.72018 2.91667 4.375 2.91667C4.02982 2.91667 3.75 3.19649 3.75 3.54167V6.04167C3.75 6.38684 4.02982 6.66667 4.375 6.66667H6.875C7.22018 6.66667 7.5 6.38684 7.5 6.04167C7.5 5.69649 7.22018 5.41667 6.875 5.41667H5.75078C6.86589 4.38235 8.3591 3.75 10 3.75Z",
    fill: "#222729"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterReset);
export default __webpack_public_path__ + "static/media/icon-filter-reset.f77e0221dfb69ef4b011aff870681627.svg";
export { ForwardRef as ReactComponent };